import { lazy } from 'react';

export default {
  path: '/users',
  component: lazy(() => import(/* webpackChunkName: 'Users' */ './page'))
};
